import { flow, reject } from 'lodash/fp';
import { isExclusiveFeature } from 'modules/features';
import prepareOptions from '../../prepareOptions';
import {
  PRIVATE_SALE,
  MERCHANT,
  RETAIL,
  PRIVATE_LISTING_SELLER,
} from './values';
import { EXCLUSIVE, DEALER, ONLINE_DEALER, PRIVATE } from './providers';

export default flow(
  reject(({ provider }) => provider === EXCLUSIVE && !isExclusiveFeature),
  prepareOptions,
)([
  {
    label: __('search.filters.exclusive'),
    provider: EXCLUSIVE,
    value: [MERCHANT],
  },
  {
    label: __('search.filters.dealer'),
    provider: DEALER,
    value: [MERCHANT, RETAIL],
  },
  {
    label: __('search.filters.retail'),
    provider: ONLINE_DEALER,
    value: [RETAIL],
  },
  {
    label: __('search.filters.private'),
    provider: PRIVATE,
    value: [PRIVATE_SALE, PRIVATE_LISTING_SELLER],
  },
]);
